/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {openRedPocketEnvelope} from '../api'

export const useMutationOpenRedPocketEnvelope = createReactQueryMutationHook('openRedPocketEnvelope', openRedPocketEnvelope)
